































import Vue, { PropOptions } from 'vue';
import Parts from '@/parts';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';
import LoginMenu from '@/components/LoginMenu.vue';
import TopBar from '@/components/TopBar.vue';

const APPMODE = process.env.VUE_APP_MODE;
const APPMODE_DEMO = 'DEMO';
const APPMODE_PROD = 'PROD';
const APPMODE_MENTE = 'MENTE';


export default Vue.extend({
  name: 'app',
  components: { ...Parts, TopBar, LoginMenu },
  data() {
    return {
      dialogMessage: '',
      errorTitle: '',
      errorMessage: '',
      myData: {} as Models.ICoordinator,
      loginFlag: false,
      visible: false,
      loading: false,
      localDatas: new Models.CLocalDatas(),
      sendFlag: true,
      getDatas: new Models.CGetDatas(),
    };
  },
  async mounted() {
    // console.log('mounted');
    // token チェック
    await this.check();
    // localData読み込み
    const getData = localStorage.getItem('peacock_local');
    if (getData) {
      this.localDatas = JSON.parse(getData);
    }

    this.visible = true;
  },
  methods: {
    test() {
      for (let ix = 0; ix < 200; ix++) {
        this.dialogMessage += 'a';
      }
    },
    showModal(message: string) {
      this.dialogMessage  = message;
    },
    showErrorModal(erroObject: any) {
      this.errorTitle  = erroObject.title;
      this.errorMessage  = erroObject.message;
    },
    closeModal() {
      this.dialogMessage = '';
    },
    closeErrorModal() {
      this.errorTitle  = '';
      this.errorMessage  = '';
    },
    async check() {
      // token チェック
      const api = new PClass.API();
      if (api.getToken()) {
        const res = await api.get<Models.ICoordinator>('auth/check');
        if (!res.result.error) {
          this.loginFlag = true;
          this.myData = res.data;
          // console.log(this.myData);
        } else {
          this.loginFlag = false;
          api.removeToken();
          // this.$emit('info', res.result.message);
          this.$emit('errorInfo', res.result);
        }
      }
    },
    async login(inputData: Models.IAuth) {
      // API
      const api = new PClass.API();
      const res = await api.post<Models.IAuth, any>('auth/login', inputData);

      if (!res.result.error) {
        await this.check();
      } else {
        // this.$emit('info', res.result.message);
        this.$emit('errorInfo', res.result);
      }
    },
    logout() {
      const api = new PClass.API();
      api.removeToken();
      this.loginFlag = false;
    },
    async confirmDialog(message: string): Promise<any> {
      return await new Promise((resolve) => {
        const VM = Vue.extend(Parts.ConfrimDialog);
        return new VM({
          parent: this,
          propsData: {
            message,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    async oneWayDialog(message: string): Promise<any> {
      return await new Promise((resolve) => {
        const VM = Vue.extend(Parts.OnewayDialog);
        return new VM({
          parent: this,
          propsData: {
            message,
            okAction: () => resolve(true),
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    showLoading(flag: boolean) {
      this.loading = flag;
    },
    setLocalDatas() {
      localStorage.setItem('peacock_local', JSON.stringify(this.localDatas));
    },
    /*
    async sendMail(mailData: Models.VSendData) {
      this.sendFlag = false;
      const api = new PClass.API();
      const res = await api.post<Models.VSendData, any>('mail/send', mailData);
      // console.log('send log', res);
      if (!res.result.error) {
        await this.oneWayDialog('メールを送信しました。\n\n配信失敗または停止連絡がきた場合、\n顧客情報からメール配信停止をお願いします。');
        // this.$emit('info', 'メールを送信しました。\n\nメールが送信に失敗および苦情が来た場合、\nすみやかにメール配信停止をお願いいたします。');
      } else {
        await this.oneWayDialog(res.result.message ? res.result.message : '送信しました。');
      }
      this.sendFlag = true;
    },
    */
    async sendSet(mailData: Models.VSendData) {
      this.loading = true;
      this.sendFlag = false;
      const api = new PClass.API();
      const res = await api.post<Models.VSendData, any>('mail/set', mailData);
      console.log('send log', res);
      if (!res.result.error) {
        // await this.oneWayDialog('メール送信予約をしました。\n\n配信失敗または停止連絡がきた場合、\n顧客情報からメール配信停止をお願いします。');
        await this.oneWayDialog('メール送信登録をしました。\n\n配信失敗または停止連絡がきた場合、\n顧客情報からメール配信停止をお願いします。');
      } else {
        await this.oneWayDialog(res.result.message ? res.result.message : '送信しました。');
      }
      this.sendFlag = true;
      this.loading = false;
    },
    async setCancel(mailData: Models.VSendData) {
      console.log('xx setCancel');
      this.loading = true;
      this.sendFlag = false;
      const api = new PClass.API();
      const res = await api.post<Models.VSendData, any>('mail/set-cancel', mailData);
      console.log('setCancel', res);
      if (!res.result.error) {
        await this.oneWayDialog('メール送信予約を停止しました。');
      } else {
        await this.oneWayDialog('送信予約停止に失敗しました。管理者に連絡してください。');
        console.log('xx setCancel');
      }
      this.sendFlag = true;
      this.loading = false;
    },
  },
});
